import {
    Container,
    Form,
    Button,
    Row,
    Col
    // InputGroup,
    // FormControl
  } from "react-bootstrap";
  
  import { useForm,setValue } from "react-hook-form";
  import { useNavigate, useLocation } from "react-router-dom";
  import { useState,useEffect }  from "react";
  import "../../../../css/common.css";
  import * as VhfLang from "../VhfLang";

  import * as Const from "../../../common/const"
  import ShipInfo from "../eq/ShipInfo";
  import InputHelperBootstrap from "../../../helper/InputHelperBootstrap"
  import StepperHelper from "../../../helper/stepperHelper/StepperHelper"


const GetTrueFromString=(value)=>{
  
  if(value==='true')return true;
  return false;
}



const CompanyContact = () => {

    const navigate = useNavigate();
    const {state} = useLocation();
    const [InvoiceAddressChkChecked, setInvoiceAddressChkChecked] = useState(GetTrueFromString(sessionStorage.getItem(VhfLang.InvoiceAddressChkId)));

    const {
      unregister,
      setValue ,
      register,
      handleSubmit,
      watch,
      getValues,
      formState: { errors }
    } = useForm();
  
  
    //set values from session storage
      var values=JSON.parse(sessionStorage.getItem(VhfLang.KeyForSessionForCompanyContact));
      if(values!=null){
        setValue(VhfLang.CompanyId,values[VhfLang.CompanyId]) 
        setValue(VhfLang.OrgNoId,values[VhfLang.OrgNoId]) 
        setValue(VhfLang.ContactId,values[VhfLang.ContactId]) 

        setValue(VhfLang.Address1Id,values[VhfLang.Address1Id]) 
        setValue(VhfLang.Address2Id,values[VhfLang.Address2Id]) 
        setValue(VhfLang.ZipcodeId,values[VhfLang.ZipcodeId]) 

        
        setValue(VhfLang.CityId,values[VhfLang.CityId]) 
        setValue(VhfLang.CountryId,values[VhfLang.CountryId]) 
        setValue(VhfLang.PhoneId,values[VhfLang.PhoneId]) 
        setValue(VhfLang.EmailId,values[VhfLang.EmailId]) 

        //invoiceinfo
        setValue(VhfLang.InvoiceAddress1Id,values[VhfLang.InvoiceAddress1Id]) 
        setValue(VhfLang.InvoiceAddress2Id,values[VhfLang.InvoiceAddress2Id]) 
        setValue(VhfLang.InvoiceRefId,values[VhfLang.InvoiceRefId]) 

        setValue(VhfLang.InvoiceZipcodeId,values[VhfLang.InvoiceZipcodeId]) 
        setValue(VhfLang.InvoiceCityId,values[VhfLang.InvoiceCityId]) 
        setValue(VhfLang.InvoiceCountryId,values[VhfLang.InvoiceCountryId]) 
    }
  
    const handleChangeInvoiceAddressChk = (event) => {
      sessionStorage.setItem(VhfLang.InvoiceAddressChkId,event.target.checked);
      setInvoiceAddressChkChecked(event.target.checked);
    }
    
    const onSubmit = (values) => {
      sessionStorage.setItem(VhfLang.KeyForSessionForCompanyContact, JSON.stringify(values));
      navigate(VhfLang.NavShipInfo, {
        state: {
          values,
        },
      });
    };

    const goBack = () => {
      // avoid receiving a PointerEvent or other non-serializable object
      // when this is used as an onClick handler. Read serializable
      // values from the form (or fallback to sessionStorage).
      const currentValues = typeof getValues === 'function'
        ? getValues()
        : (JSON.parse(sessionStorage.getItem(VhfLang.KeyForSessionForCompanyContact)) || {});

      navigate(VhfLang.NavStartPage, {
        state: {
          values: currentValues,
        },
      });
    };

    return(

        <Form onSubmit={handleSubmit(onSubmit)}>
          <StepperHelper activeStep={1}></StepperHelper>
        <fieldset >
          <h2>{VhfLang.CompanyLegendH2}</h2>
          <h3>{VhfLang.CompanyLegend}</h3>
        <InputHelperBootstrap register={register(VhfLang.CompanyId, { required: true })} error={errors[VhfLang.CompanyId]} id={VhfLang.CompanyId} label={VhfLang.CompanyLabel}  placeholder= {VhfLang.CompanyPlaceHolder} errorRequiredText= {VhfLang.CompanyError} ></InputHelperBootstrap>
        <InputHelperBootstrap register={register(VhfLang.OrgNoId, {
                  required: true,
                  pattern: /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([-+]?)?((?!000)\d{3})(\d)$/g})
                  } error={errors[VhfLang.OrgNoId]}  id={VhfLang.OrgNoId} label={VhfLang.OrgNoLabel}  placeholder={VhfLang.OrgNoPlaceHolder} errorRequiredText={VhfLang.OrgNoError} errorPatternText={VhfLang.OrgNoError}></InputHelperBootstrap>
        <InputHelperBootstrap register={register(VhfLang.ContactId, { required: true })} error={errors[VhfLang.ContactId]} id={VhfLang.ContactId} label={VhfLang.ContactLabel}  placeholder= {VhfLang.ContactPlaceHolder} errorRequiredText= {VhfLang.ContactError} ></InputHelperBootstrap>
        <InputHelperBootstrap register={register(VhfLang.PhoneId, { required: true})} error={errors[VhfLang.PhoneId]}  id={VhfLang.PhoneId} label={VhfLang.PhoneLabel}   errorRequiredText= {VhfLang.PhoneError} ></InputHelperBootstrap>
        <InputHelperBootstrap register={register(VhfLang.EmailId, { required: true, pattern: Const.emailRegex  })} error={errors[VhfLang.EmailId]} errorPatternText={VhfLang.EmailPatternError}  id={VhfLang.EmailId} label={VhfLang.EmailLabel}  placeholder= {VhfLang.EmailPlaceHolder} errorRequiredText= {VhfLang.EmailError} ></InputHelperBootstrap>
        </fieldset>
                   
       
        <fieldset className="sp">
              <h3>{VhfLang.CompanyAddressLegend}</h3>
              <InputHelperBootstrap register={register(VhfLang.Address1Id, { required: false})} error={errors[VhfLang.Address1Id]} id={VhfLang.Address1Id} label={VhfLang.Address1Label}  placeholder={VhfLang.Address1PlaceHolder} ></InputHelperBootstrap>
              <InputHelperBootstrap register={register(VhfLang.Address2Id, { required: false })}   error={errors[VhfLang.Address2Id]} id={VhfLang.Address2Id} label={VhfLang.Address2Label}  placeholder={VhfLang.Address2PlaceHolder} ></InputHelperBootstrap>
            <Row>
                <Col>
                    <InputHelperBootstrap register={register(VhfLang.ZipcodeId, { required: true })} error={errors[VhfLang.ZipcodeId]} id={VhfLang.ZipcodeId} label={VhfLang.ZipcodeLabel}  placeholder={VhfLang.ZipcodePlaceHolder}  errorRequiredText={VhfLang.ZipcodeError} ></InputHelperBootstrap>
                </Col>
                <Col>
                    <InputHelperBootstrap register={register(VhfLang.CityId, { required: true })} error={errors[VhfLang.CityId]} id={VhfLang.CityId} label={VhfLang.CityLabel}  placeholder={VhfLang.CityPlaceHolder} errorRequiredText={VhfLang.CityError} ></InputHelperBootstrap>
                </Col>
                <Col>
                    <InputHelperBootstrap register={register(VhfLang.CountryId, { required: true })} error={errors[VhfLang.CountryId]} id={VhfLang.CountryId} label={VhfLang.CountryLabel} placeholder={VhfLang.CountryPlaceHolder}  errorRequiredText={VhfLang.CountryError} defaultValue={VhfLang.SwedenDefaultCountry}></InputHelperBootstrap>
                </Col>
              </Row>
              
            </fieldset>
        
            
            
            <fieldset>
                <Form.Check
                  inline
                  label={VhfLang.InvoiceAddressChkLabel}
                  name={VhfLang.InvoiceAddressChkId}
                  type="checkBox"
                  id={VhfLang.InvoiceAddressChkId}
                  onChange={handleChangeInvoiceAddressChk}
                  checked={InvoiceAddressChkChecked}
                  />

  {InvoiceAddressChkChecked ? (
    <>
    <h3></h3>
    
      <InputHelperBootstrap register={register(VhfLang.InvoiceAddress1Id, { required: false})} error={errors[VhfLang.InvoiceAddress1Id]} id={VhfLang.InvoiceAddress1Id} label={VhfLang.InvoiceAddress1Label}  placeholder={VhfLang.InvoiceAddress1PlaceHolder} ></InputHelperBootstrap>
      <InputHelperBootstrap register={register(VhfLang.InvoiceAddress2Id, { required: false })}   id={VhfLang.InvoiceAddress2Id} label={VhfLang.InvoiceAddress2Label}  placeholder={VhfLang.InvoiceAddress2PlaceHolder}   ></InputHelperBootstrap>
      <InputHelperBootstrap register={register(VhfLang.InvoiceRefId, { required: false })}   id={VhfLang.InvoiceRefId} label={VhfLang.InvoiceRefLabel}  placeholder={VhfLang.InvoiceRefPlaceHolder}></InputHelperBootstrap>
    <Row>
      <Col>
          <InputHelperBootstrap register={register(VhfLang.InvoiceZipcodeId, { required: true })} error={errors[VhfLang.InvoiceZipcodeId]} id={VhfLang.InvoiceZipcodeId} label={VhfLang.InvoiceZipcodeLabel}  placeholder={VhfLang.InvoiceZipcodePlaceHolder}  errorRequiredText={VhfLang.InvoiceZipcodeError} ></InputHelperBootstrap>
      </Col>
      <Col>
          <InputHelperBootstrap register={register(VhfLang.InvoiceCityId, { required: true })} error={errors[VhfLang.InvoiceCityId]} id={VhfLang.InvoiceCityId} label={VhfLang.InvoiceCityLabel}  placeholder={VhfLang.InvoiceCityPlaceHolder} errorRequiredText={VhfLang.InvoiceCityError} ></InputHelperBootstrap>
      </Col>
      <Col>
        <InputHelperBootstrap register={register(VhfLang.InvoiceCountryId, { required: true })} error={errors[VhfLang.InvoiceCountryId]} id={VhfLang.InvoiceCountryId} label={VhfLang.InvoiceCountryLabel} placeholder={VhfLang.InvoiceCountryPlaceHolder}  errorRequiredText={VhfLang.InvoiceCountryError} defaultValue={VhfLang.SwedenDefaultCountry}></InputHelperBootstrap>
      </Col>
    </Row>
    </>    
        ):(<>            
              </>)}

              <br></br>
              <div className="float-end">
            <Button variant="back" type="button"  onClick={goBack} className="button-margin">
            {VhfLang.ButtonPreviousDisplay}
                  </Button>
        <Button variant="forward" type="submit" className="button-margin">
        {VhfLang.ButtonNextDisplay}
                  </Button>
                  </div>

     </fieldset>

          
                  

        </Form>

    )

}

export default CompanyContact


